export default __webpack_public_path__ + "static/media/Great Cloak of Tribal Prayers.c5269926.jpg";